import _extends from "@babel/runtime/helpers/extends";
/**
 * This file generated by Stencil generateIcons scripts
 * DO NOT EDIT DIRECTLY
 */

import React from 'react';
import { withIconProps } from '../utils/withIconProps';
import { jsx as ___EmotionJSX } from "@emotion/react";
const IconArrowLeftMedium = withIconProps(props => {
  return ___EmotionJSX("svg", _extends({
    width: "24px",
    height: "24px",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), ___EmotionJSX("path", {
    d: "M8.70711 6.70711C9.09763 6.31658 9.09763 5.68342 8.70711 5.29289C8.31658 4.90237 7.68342 4.90237 7.29289 5.29289L1.29289 11.2929C0.902369 11.6834 0.902369 12.3166 1.29289 12.7071L7.29289 18.7071C7.68342 19.0976 8.31658 19.0976 8.70711 18.7071C9.09763 18.3166 9.09763 17.6834 8.70711 17.2929L4.41421 13H22C22.5523 13 23 12.5523 23 12C23 11.4477 22.5523 11 22 11H4.41421L8.70711 6.70711Z",
    fill: "currentColor"
  }));
}, 'IconArrowLeftMedium');
IconArrowLeftMedium.displayName = 'IconArrowLeftMedium';
export default IconArrowLeftMedium;